import { useHref, useLocation } from 'react-router-dom';

import { buildLoginUrl } from '@/utils/redirectHelpers';

export const useLoginRedirectUrl = () => {
    const location = useLocation();
    return buildLoginUrl(useHref(`${location.pathname}${location.search}${location.hash}`));
};
